const PIXEL_ID = '962279486187488'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      loaded?: boolean
    }
    _fbq?: unknown
  }
}

type EventParams = Record<string, string | number>

type FiredEvent = { name: string; params?: EventParams }

const fired: FiredEvent[] = []
let injected = false
let fallbackMode = false

/**
 * Fires the event through the image endpoint Meta exposes for the <noscript>
 * case. Used only when fbevents.js cannot load (ad blocker, sandboxed
 * preview, strict CSP) so no conversion is silently lost.
 */
function sendBeacon({ name, params }: FiredEvent) {
  const query = new URLSearchParams({
    id: PIXEL_ID,
    ev: name,
    dl: window.location.href,
    rl: document.referrer,
    if: 'false',
    ts: String(Date.now()),
    noscript: '1',
  })

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      query.append(`cd[${key}]`, String(value))
    })
  }

  const img = new Image(1, 1)
  img.referrerPolicy = 'no-referrer-when-downgrade'
  img.src = `https://www.facebook.com/tr?${query.toString()}`
}

/**
 * Injects the official Meta Pixel base snippet as an inline script so the
 * pixel is discoverable by Meta Pixel Helper, then verifies fbevents.js
 * actually booted; if it did not, every event is replayed over the beacon.
 */
function injectBaseCode() {
  if (injected) return
  injected = true

  const script = document.createElement('script')
  script.id = 'meta-pixel-base'
  script.text = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');`
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.alt = ''
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.head.appendChild(noscript)

  window.setTimeout(() => {
    if (window.fbq && window.fbq.callMethod) return
    fallbackMode = true
    fired.forEach(sendBeacon)
  }, 2500)
}

function track(name: string, params?: EventParams) {
  injectBaseCode()
  fired.push({ name, params })

  if (fallbackMode) {
    sendBeacon({ name, params })
    return
  }

  if (typeof window.fbq === 'function') {
    if (params) {
      window.fbq('track', name, params)
    } else {
      window.fbq('track', name)
    }
  } else {
    sendBeacon({ name, params })
  }
}

let pageViewSent = false

/** Loads the pixel and fires a single PageView on page load. */
export function initMetaPixel() {
  if (typeof window === 'undefined' || pageViewSent) return
  pageViewSent = true
  track('PageView')
}

/** Fires AddToCart right before sending the visitor to the Hotmart checkout. */
export function trackAddToCart() {
  track('AddToCart', {
    content_name: 'El Metodo de Vaciado Biologico',
    content_type: 'product',
    content_ids: 'I107312371O',
    value: 9.99,
    currency: 'USD',
  })
}
